'use client'

import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { Button } from '@/components/Button'
import { ArrowRightCircle } from '@/components/Icons'

export default function ApplyDialog ({ open, onClose }) {

  return (
    <Dialog open={open} onClose={onClose} className='relative z-50'>
        <DialogBackdrop
          transition
          className='fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in'
        />

        <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
          <div className='flex min-h-full items-end justify-center p-6 text-center sm:items-center sm:p-0'>
            <DialogPanel
              transition
              className='relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95'
            >

              <div className=''>
                <DialogTitle as='h3' className='text-lg font-semibold mb-2 leading-[1.2] tracking-tight'>
                  Are you an existing customer?
                </DialogTitle>
                <div className='mt-2'>
                  <p className='text-sm text-default-600 mb-6'>Existing customers can quickly and easily complete an application through myUDC.</p>
                  <div className='flex flex-col gap-2'>
                    <Button href='https://my.udc.co.nz/logon' target='_blank' size='sm' variant='primary' className='w-full'>
                      <span className='block relative pr-5'>Go to myUDC <ArrowRightCircle className='absolute right-0 top-1/2 -mt-[7px]' /></span>
                    </Button>

                    <Button href='https://online.udc.co.nz/' target='_blank' size='sm' variant='secondary' className='w-full'>
                      <span className='block relative pr-5'>Continue to online application <ArrowRightCircle className='absolute right-0 top-1/2 -mt-[7px]' /></span>
                    </Button>
                  </div>
                </div>
              </div>

            </DialogPanel>
          </div>
        </div>
      </Dialog>
  )
}
